export default __webpack_public_path__ + "static/media/darkarky.df23033d.png";